/* HFB-055-MD-CP-AB — desktop drag-to-scroll for category pill nav */
document.addEventListener('DOMContentLoaded', function () {
  var list = document.querySelector('.sortv3-nav__list');
  if (!list) return;

  var desktopMq = window.matchMedia('(min-width: 750px)');
  var pointerDown = false;
  var startX = 0;
  var scrollStart = 0;
  var dragged = false;
  var dragThreshold = 5;

  function isScrollable() {
    return list.scrollWidth > list.clientWidth + 1;
  }

  function canDrag(e) {
    if (!desktopMq.matches) return false;
    if (e.pointerType === 'touch') return false;
    return isScrollable();
  }

  list.addEventListener('pointerdown', function (e) {
    if (!canDrag(e)) return;
    if (e.button !== undefined && e.button !== 0) return;
    pointerDown = true;
    dragged = false;
    startX = e.clientX;
    scrollStart = list.scrollLeft;
    list.classList.add('sortv3-nav__list--dragging');
    if (list.setPointerCapture) {
      try {
        list.setPointerCapture(e.pointerId);
      } catch (err) {
        /* ignore */
      }
    }
  });

  list.addEventListener('pointermove', function (e) {
    if (!pointerDown) return;
    var dx = e.clientX - startX;
    if (Math.abs(dx) > dragThreshold) dragged = true;
    if (!dragged) return;
    list.scrollLeft = scrollStart - dx;
    e.preventDefault();
  });

  function endDrag(e) {
    if (!pointerDown) return;
    pointerDown = false;
    list.classList.remove('sortv3-nav__list--dragging');
    if (list.releasePointerCapture && e && e.pointerId !== undefined) {
      try {
        list.releasePointerCapture(e.pointerId);
      } catch (err) {
        /* ignore */
      }
    }
  }

  list.addEventListener('pointerup', endDrag);
  list.addEventListener('pointercancel', endDrag);
  list.addEventListener('lostpointercapture', function () {
    pointerDown = false;
    list.classList.remove('sortv3-nav__list--dragging');
  });

  list.addEventListener(
    'click',
    function (e) {
      if (!dragged) return;
      var link = e.target.closest('.sortv3-nav__link');
      if (!link) return;
      e.preventDefault();
      e.stopPropagation();
      dragged = false;
    },
    true
  );
});
